import React, { Component } from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import Waypoint from 'react-waypoint';
import styled from "react-emotion";

const Revealable = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  margin-top: ${({ show }) => (show ? "0" : "100px")};
  transition: opacity ease-out 0.5s, margin-top cubic-bezier(0, 0, 0.58, 1) 1s;`;

class Reveal extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <Revealable show={this.state.revealed}>
          {this.props.children}
        </Revealable>
      </Waypoint>
    );
  }
}

const SlidingUp = styled("div")`
  opacity: ${({ show }) => (show ? "100" : "0")};
  transform: ${({ show }) => (show ? "translate(0,100px)" : "translate(0,0)")};
  transition: opacity ease-out 0.5s, transform cubic-bezier(0, 0, 0.58, 1) 1s;`;

class SlideUp extends Component {
  state = {
    revealed: false
  };
  reveal = () => {
    this.setState({ revealed: true });
  };
  render() {
    return (
      <Waypoint onEnter={this.reveal}>
        <SlidingUp show={this.state.revealed}>
          {this.props.children}
        </SlidingUp>
      </Waypoint>
    );
  }
}

const HeavenlyPioneeringPage = () => (
    <section>
    <Helmet title="Celebrating Mastery" />
                  <div className="mastery-nav">
                    <Link to="/celebrating-mastery" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_passion.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">PASSION</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-tenacity" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_tenacity.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">TENACITY</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-pioneering" className="mastery-nav-link allegre active"><img className="img-responsive" src={require('../../images/_stories/illustration_pioneering.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PIONEERING</span></span></Link>
                    <Link to="/celebrating-mastery/heavenly-patience" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_patience.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">PATIENCE</span></span></Link> 
                    <Link to="/celebrating-mastery/heavenly-ritual" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_ritual.png')} /><span className="mastery-nav-link-text">HEAVENLY <span className="red">RITUAL</span></span></Link>
                    <Link to="/celebrating-mastery/devilish-details" className="mastery-nav-link allegre"><img className="img-responsive" src={require('../../images/_stories/illustration_details.png')} /><span className="mastery-nav-link-text">DEVILISH <span className="red">DETAILS</span></span></Link>  
                  </div>
          {/*PIONEERING*/}
          <div className="mastery-block">
              <div className="mastery-block-header">
                <div className="grid-xl container">
                  <div className="columns">
                    <div className="column col-4 col-sm-12"><img className="img-responsive" src={require('../../images/_stories/illustration_pioneering.png')} /></div>
                    <div className="column col-6 col-sm-12">
                      <h1 className="allegre">HEAVENLY <span className="red">PIONEERING</span></h1>
                      <h4>先んずれば天を制す</h4>
                       <p>1918年、デュベル・モルトガット醸造所は瓶内2次発酵を開発し、ビールの歴史を変えた。そうして生まれたクリスタルのような澄んだ色味のゴールデン・エール、デュベルは、天にも昇るおいしさで世間を驚かせた。そう、人類は月に到達するよりずっと前、天国に到達していたのだ。たとえそれが、悪魔の仕業だったとしても。</p>
                    </div>
                  </div>
                </div>
            </div>
            <div className="mastery-block-body relative">
               <img className="mastery-big-d" src={require('../../images/D_logo.png')} />                
            <div className="grid-xl container">
                  <div className="columns">
                      <div className="column col-6 col-md-12">
                      <div className="mastery-block-text"><h4 className="red">知られざるベルギーのパイオニアたち</h4>
                       <p>ベルギーを代表するパイオニアは、何もデュベル・モルトガットだけではない。
たとえばベルギー人元司法長官でベルギーBBC放送局長だったヴィクトル・ド・ラブレーは、第二次世界大戦中、国民を導くシンボルとして “勝利”（仏語）と“自由”（蘭語）を象徴する“V”を表す“Vサイン”を考案した。もちろんその後、彼のサインが日本の若い女性たちにとって写真を撮る際より小顔に見せるためのポーズになるとは、誰も想像していなかったに違いない。<br/>また、あなたが今これをウェブページで読んでいるのも、実はベルギー人のおかげというのをご存知だろうか？今やお馴染みのウェブブラウザ、ワールドワイドウェブは、1990年にベルギーの情報科学技術者及びコンピュータ科学者のロバート・カイリューが共同開発したものだ。また話を宇宙に戻すと、1957年、打ち上げられたロケット“アトラス”のエンジニアはカレル・ヤン・ボサートというベルギー人。彼のロケットが後のアポロ13の布石となったことは言うまでもない。</p>
                      <p>どちらにしても、デュベル醸造所のパイオニア精神に匹敵する偉業は、どこを探しても見当たらないようだ。</p>
                      <img className="img-responsive img-60" src={require('../../images/_stories/_pioneering/pioneering_robert_cailliau.jpg')} />
                      </div>
                      </div>
                      <div className="column col-6 col-md-12">
                        <img className="img-responsive img-60" src={require('../../images/_stories/_pioneering/pioneering_karel_bossart.jpg')} />
                    </div>
                    <div className="mastery-block-img-footer">                                                     
                    <img className="img-responsive" src={require('../../images/_stories/illustration_pioneering.png')} />
                  </div></div>
             </div>
            </div>
        </div>
    </section>
  
)

export default HeavenlyPioneeringPage



// WEBPACK FOOTER //
// ./src/pages/celebrating-mastery/heavenly-pioneering.js